module.exports = __webpack_public_path__ + "img/coming-soon.d2291b72.svg";